import { Subscription } from 'rxjs';

import { FastLaneItems } from './fastlane-datacenter-config';

export interface FastLaneRequest {
	id?: number;
	rfqNumber?: string;
	offerId?: string;
	creatorUser?: User;
	organization?: Organization;
	requestName: string;
	soldTo: BOC | string;
	shipToType?: null | string;
	shipTo?: null | string;
	shipToCustom?: null | string;
	shipToPerson?: null | string;
	shipToContact?: null | string;
	description?: string;
	currency: Translation | string;
	creationDate?: Date;
	modificationDate?: Date;
	fastLaneItems?: FastLaneItem[];
	fastLaneRequestAttachment?: FastLaneRequestAttachmentSubmit[];
}
interface User {
	id: number;
	firstName: string;
	lastName: string;
}
interface Organization {
	memberId: string;
	memberName: string;
}
export interface BOC {
	id: number;
	address: string;
	transcoSystem: string;
	businessId: string;
	name: string;
	country: string;
	city: string;
	stuClientId: number;
	postalCode: string;
}
interface Translation {
	code: string;
	value: string;
}
export interface ValueAndDisplay {
	value: string;
	display: string;
}
export interface FastLaneItem {
	id?: number;
	protoTypeRef?: string;
	itemNumber: string;
	status?: Translation | string;
	name: string;
	steelgrade: string;
	form: Translation | string;
	thickness: number;
	width: number;
	length: number;
	sheetWeightKg?: number;
	quantity: number;
	quantityUnit: Translation | string;
	blankWeight?: number;
	coating: string;
	coilAxis?: Translation | string;
	oiling?: string;
	innerDiameter?: string;
	maxOutsideDiameter?: number;
	additionalItemInfo?: string;
	creationDate?: Date;
	modificationDate?: Date;
	rddType?: Translation | string;
	rddDate?: Date | string;
	rddDisplay?: string;
	transportMode?: string;
	incoterms?: string;
	packing?: string;
	plant?: string;
	totalWeight?: number;
	shipToType?: null | string;
	shipTo?: null | string;
	shipToCustom?: null | string;
	shipToPerson?: null | string;
	shipToContact?: null | string;
	fastLaneRequestItemAttachments?: FastLaneRequestAttachmentSubmit[];
}
export interface BocOpt {
	soldTo?: string;
	shipTo?: string;
}

export function createDefaultPrototype() {
	return <FastLaneRequest> {};
}
export interface FastLaneRequestItem extends FastLaneItem {
	fastLaneRequestItemAttachments: FastLaneRequestAttachment[];
}

export interface FastLaneRequestAttachment extends FastLaneRequestAttachmentSubmit {
	id?: number | undefined;
	path?: string;
	localUrl: string;
	localFile?: File | undefined;
	error?: false;
	sending?: false;
	progress?: number | undefined;
	uploadSub?: Subscription;
}

export interface FastLaneRequestAttachmentForm {
	fastlaneAttachment: FastLaneRequestAttachment;
}

export interface FastLaneRequestAttachmentSubmit {
	fileName: string;
	type: string;
	fileSize: number;
	chronicleId?: string;
	hash: string;
}

export interface ErrorResponse {
	error: string;
}
export type FieldOfFastLaneItems = keyof FastLaneItems;

export const DATETIME_FORMAT_PATTERN = 'YYYY-MM-DD[T]HH:mm:ss.SSSS';
